import React, { Component } from 'react'
import propTypes from './types'
import SelectComponent from './select'

export default class Select extends Component {
  static propTypes = propTypes

  state = { open: false }

  componentWillUnmount() {
    this.unmount()
  }

  unmount = () => {
    window.removeEventListener('click', this.onBackgroundClick)
    window.removeEventListener('touchstart', this.onBackgroundClick)
  }

  onBackgroundClick = e => {
    if (this.rendered.contains(e.target)) {
      return
    }

    this.unmount()
    this.setState({ open: false })
  }

  onClick = e => {
    if (this.state.open) {
      this.unmount()
      this.setState({ open: false })
      return
    }

    window.addEventListener('click', this.onBackgroundClick)
    window.addEventListener('touchstart', this.onBackgroundClick)
    this.setState({ open: true })
  }

  render() {
    return (
      <SelectComponent
        {...this.props}
        open={this.state.open}
        innerRef={elem => {
          this.rendered = elem
        }}
        onClicks={{
          trigger: this.onClick,
          option: this.onClick,
        }}
      />
    )
  }
}
